import type { GetClientPreferencesData, RelatedPassengerPreferencesData } from '@/types/clientsApiTypes';

const emptyGetClientPreferencesData = (): GetClientPreferencesData => ({
  allergies: null,
  beverage_preferences: [],
  spa_preferences_special_requests: null,
  amenities_traveling_other: [],
  pillows: [],
  wine: [],
  travel: null,
  stay: {},
  fly: {
    preferred_private_aviation_company: null,
    fly_private_aviation: null,
    seat: 'Window',
    class_preference: [],
  },
  tsa: { global_expiry_date: null },
  personal: {
    information: null,
    comfort_related: {
      us: { height: null, weight: null },
      metric: { height: null, weight: null },
      information: null,
    },
  },
});

export function mapRelatedPreferenceDataToGetClientPreferencesData(
  related?: RelatedPassengerPreferencesData | null
): GetClientPreferencesData {
  if (related == null) {
    return emptyGetClientPreferencesData();
  }

  const fly = related.fly;
  const base = emptyGetClientPreferencesData();

  return {
    ...base,
    allergies: related.allergies ?? null,
    general_interests: related.general_interests,
    fly: fly
      ? {
          preferred_private_aviation_company: fly.preferred_private_aviation_company ?? null,
          fly_private_aviation: fly.fly_private_aviation,
          seat: fly.seat ?? 'Window',
          class_preference: fly.class_preference ?? [],
        }
      : base.fly,
    personal: {
      personal_metric_system: related.personal?.personal_metric_system ?? 'us',
      information: related.personal?.information ?? null,
      comfort_related: {
        us: {
          height: related.personal?.comfort_related?.us?.height ?? null,
          weight: related.personal?.comfort_related?.us?.weight ?? null,
        },
        metric: {
          height: related.personal?.comfort_related?.metric?.height ?? null,
          weight: related.personal?.comfort_related?.metric?.weight ?? null,
        },
        information: null,
      },
    },
  };
}
